import "@partials/ui/preloader/preloader.js";
import "@partials/ui/langs/langs";
// import '@partials/header/header.js';
import "@partials/swimming-chat/swimming-chat.js";
import "@partials/popups/popup-form/popup-form.js";
import "@partials/popups/popup-form/form/form.js";
import "@partials/mobile-menu/mobile-menu.js";
import "@partials/screen/faq-screen/faq-screen.js";
import Accordion from "@partials/ui/ui-accordion/ui-accordion.js";

// TODO Sticky elements
window.addEventListener("load", () => {
    fadeInNavOnScroll("header.header-sticky", 150);
});

window.addEventListener("scroll", () => {
    fadeInNavOnScroll("header.header-sticky", 150);
});

function fadeInNavOnScroll(elements, distance) {
    let items = document?.querySelectorAll(elements);

    for (let i = 0; i < items.length; i++) {
        if (window.scrollY >= distance) items[i].classList.add("active");

        if (window.scrollY <= 150) items[i].classList.remove("active");
    }
}

// TODO Инициализация аккордионов
new Accordion({
    visible: ".ui-accordion__item .item-title",
    collapse: ".ui-accordion__item .item-content",
});
